import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { InboxWelcomeComponent } from "../inbox-welcome/inbox-welcome.component";
import { ISmartInboxState, ISmartInboxStateType } from '../../models/inbox.models';
import { CommonModule } from '@angular/common';
import { InboxComponent } from '../inbox-view/inbox-view.component';
import { InboxErrorComponent } from '../inbox-error/inbox-error.component';
import { AppState } from 'src/app/core/app.state';
import * as smartInboxActions from '../../store/smart-inbox.actions';
import { selectConnectionState } from '../../store/smart-inbox.selectors';
import { SHARED_INBOX } from '../../store/smart-inbox.reducers';

@Component({
  selector: 'app-inbox-page',
  standalone: true,
  templateUrl: './inbox-page.component.html',
  styleUrls: ['./inbox-page.component.scss'],
  imports: [InboxWelcomeComponent, InboxErrorComponent, InboxComponent, CommonModule],
})
export class InboxPageComponent implements OnInit, OnDestroy {
  readonly SMART_INBOX_STATE = ISmartInboxState;

  activeState: ISmartInboxStateType = ISmartInboxState.INITIAL;

  private destroy$ = new Subject<void>();

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.store.select(selectConnectionState)
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.activeState = state;
      });

    this.store.dispatch(smartInboxActions.LoadAccounts());
    // Load shared inbox KPIs so users see mentions/assignments even without a connected account
    this.store.dispatch(smartInboxActions.LoadFoldersKPIs({ accounts: [SHARED_INBOX] }));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onConnectSuccess(): void {
    this.store.dispatch(smartInboxActions.LoadAccounts());
  }

  onConnectError(error: ISmartInboxStateType): void {
    this.store.dispatch(smartInboxActions.SetConnectionState({ connectionState: error }));
  }

  onRetry(): void {
    this.store.dispatch(smartInboxActions.SetConnectionState({
      connectionState: ISmartInboxState.CONNECT,
    }));
  }
}
